import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { Row, Col, Form, FormGroup, Label, Input, Button, Card, CardBody, Navbar } from 'reactstrap';
import './Login.css';
import './Signup.css';
import headerImage from '../../../images/SignupHeader.png';
import Loading from 'react-fullscreen-loading';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

const SignupThanks = () => {
    const { state } = useLocation(); const navigate = useNavigate();
    let [success, setSuccess] = useState(false);
    let [sessionId, setSessionId] = useState('');
    let [message, setMessage] = useState('');
    const [transactionLoading, setTransactionLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const onSuccessPayment = async (TransactionId,SessionId) => {
        var form =
        {
            TransactionId: TransactionId,
            SessionId: SessionId,
        };
        const response = await axios.post(
            '/api/auth/OnSignupSuccess/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            setTransactionLoading(false);
        }
    }

    useEffect(() => {  
        let search = window.location.search;
        let params = new URLSearchParams(search);
        setTransactionLoading(true);
        const query = new URLSearchParams(window.location.search);
        if (query.get('success')) {
            setSuccess(true);
            if (searchParams.has('transId')) {
                searchParams.delete('transId');
                setSearchParams(searchParams);
            }
            if (searchParams.has('session_id')) {
                searchParams.delete('session_id');
                setSearchParams(searchParams);
            }
            if (query.get('session_id')) {
                onSuccessPayment(query.get('transId'), query.get('session_id'));
            }
            else {
                setTransactionLoading(false);
            }
        }
        if (query.get('canceled')) {
            setSuccess(false);
            setMessage(
                "Order canceled -- continue to shop around and checkout when you're ready."
            );
        }
    }, []);

    return (
        <main>
            {transactionLoading && <Loading loading background="none" loaderColor="#3498db" />}
            <header>
                <div style={{
                    backgroundImage: `url(${headerImage})`,
                    backgroundSize: 'unset',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                    height: '5vh', marginTop: "0px"
                }}><span style={{ marginLeft: "5vw", fontSize: "25px", color: "white" }}><b>THANK YOU FOR SUBSCRIBING</b></span>
                </div>
            </header>
            <body>
                <Card className="login-card">
                    <CardBody>
                        <Row>
                            <Col>
                                <span><b>Your subscription to the Fresh Plan has been successfully processed</b></span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span>Please check your email for detail it should arrive within the next 20 minutes (<i>don't forget to check your spam folder</i>).</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span>If you have any queries or questions, please don't hesitate to contact us at any time.</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span>Phone QCONZ : 0800 726 695 or Email : <u><a href='itsupport@qconz.co.nz'>itsupport@qconz.co.nz</a></u></span>
                            </Col>
                                </Row>
                    </CardBody>
                </Card>
            </body>
        </main>
        )
}
export default SignupThanks;